export const PRODUCT_JSM_ORGANIZATION_MEMBERS_LEGACY = 'PRODUCT_JSM_ORGANIZATION_MEMBERS_LEGACY';
export const PRODUCT_JSM_ORGANIZATION_MEMBERS = 'PRODUCT_JSM_ORGANIZATION_MEMBERS';
